import styles from './FJRecordSuccess.module.less';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import FJAudioWave from '../../../../common/components/FJAudioWave/FJAudioWave.jsx';
import { useRef, useState, useCallback } from 'react';
import FJUtil from '../../../../util/FJUtil.js';
import FJPauseIcon from '../../../../assets/svg/pause-black.svg?react';
import FJPlayIcon from '../../../../assets/svg/play-black.svg?react';
import PropTypes from 'prop-types';

const FJRecordSuccess = props => {
    const { url = '', name, reRecord, useRecord } = props;
    const audioRef = useRef(null);
    const [isPlay, setIsPlay] = useState(false);
    const [audioDuration, setAudioDuration] = useState(null);

    const updateDuration = useCallback(duration => {
        setAudioDuration(FJUtil.formatTime(duration, false, 2));
    }, []);

    const _changePlay = e => {
        e.stopPropagation();
        try {
            if (audioRef.current.isLoaded()) {
                setIsPlay(!isPlay);
                if (isPlay) {
                    audioRef.current.pause();
                } else {
                    audioRef.current.play();
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className={styles.box}>
            <div className={styles.title}>{name}</div>
            <div className={styles.content}>
                <div className={styles.control} onClick={_changePlay}>
                    {isPlay && <FJPauseIcon />}
                    {!isPlay && <FJPlayIcon />}
                </div>
                <div className={styles.audio_box}>
                    <FJAudioWave url={url} ref={audioRef} setIsPlay={setIsPlay} updateDuration={updateDuration} />
                </div>
                <div className={styles.duration}>{audioDuration}</div>
            </div>

            <div className={styles.btn_group}>
                <FJButton text='re-record' type='default' className={styles.btn} onClick={reRecord} />
                <FJButton text='apply' type='gradient' className={styles.btn} onClick={useRecord} disabled={!url} />
            </div>
        </div>
    );
};

FJRecordSuccess.propTypes = {
    url: PropTypes.string,
    name: PropTypes.string,
    reRecord: PropTypes.func,
    useRecord: PropTypes.func,
};

export default FJRecordSuccess;
